import type { LucideIcon } from 'lucide-react'
import { AlertCircle, ClipboardX } from 'lucide-react'
import { Button } from '@/components/learner/ui/Button'
import { LearnerLoading } from '@/components/learner/ui/LearnerLoading'
import { TestLayout } from '@/components/learner/test'

export function SpecialLectureLoading() {
  return (
    <TestLayout variant="card">
      <LearnerLoading />
    </TestLayout>
  )
}

interface SpecialLecturePageStateProps {
  kind: 'error' | 'empty'
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
}

const stateIcon: Record<SpecialLecturePageStateProps['kind'], LucideIcon> = {
  error: AlertCircle,
  empty: ClipboardX,
}

/** 평가 화면의 오류·빈 상태를 시작/대기 화면과 같은 카드 문법으로 표시한다. */
export function SpecialLecturePageState({
  kind,
  title,
  description,
  actionLabel,
  onAction,
}: SpecialLecturePageStateProps) {
  const Icon = stateIcon[kind]

  return (
    <TestLayout variant="card">
      <div
        role={kind === 'error' ? 'alert' : 'status'}
        className="flex w-full max-w-[520px] flex-col items-center gap-6 px-2 text-center sm:px-6"
      >
        <div
          className={kind === 'error'
            ? 'flex size-20 items-center justify-center rounded-full bg-lc-error-50 text-lc-error-500'
            : 'flex size-20 items-center justify-center rounded-full bg-lc-key-50 text-lc-key-500'}
        >
          <Icon className="size-10" strokeWidth={1.8} aria-hidden />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="text-lc-v3-h3 font-bold text-lc-text-primary sm:text-lc-v3-h1">
            {title}
          </h1>
          <p className="whitespace-pre-line text-lc-v3-body-1 font-medium text-lc-text-secondary">
            {description}
          </p>
        </div>
        {actionLabel && onAction ? (
          <Button size="L" className="w-full sm:w-auto sm:min-w-[120px]" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
      </div>
    </TestLayout>
  )
}
